import { createAction, props } from '@ngrx/store';
import { ErrorMessage } from '../error/error-message.model';
import { UserDTO } from './user.model';

export const updateEmail = createAction(
  '[User] updateEmail',
  props<{ newEmail: string; callbackUrl: string }>()
);

export const updateEmailSuccess = createAction(
  '[User] updateEmailSuccess',
  props<{ updatedUser: UserDTO }>()
);

export const updateEmailFailure = createAction(
  '[User] updateEmailFailure',
  props<{ error: ErrorMessage }>()
);
